import {message} from 'antd';
import axios from 'axios';
import {BASE_URL, api} from '../config';
import i18n, { getCurrentLanguage } from '../i18n';

const GET_ALL_USERS = BASE_URL + "users/";
const LOGIN_USER = BASE_URL + "users/login";
const DELETE_USER = BASE_URL + "users/";
const CREATE_USER = BASE_URL + "users/";
const REGISTER_USER = BASE_URL + "users/register";
const UPDATE_USER = BASE_URL + "users/";
const CHANGE_PASSWORD_FIRST_LOGIN = BASE_URL + "users/change-password-first-login";
const PASSWORD_RESET_REQUEST = BASE_URL + "users/password-reset/request";
const PASSWORD_RESET_VALIDATE = BASE_URL + "users/password-reset/validate";
const PASSWORD_RESET_CONFIRM = BASE_URL + "users/password-reset/confirm";
const EMAIL_VERIFICATION_RESEND = BASE_URL + "users/email-verification/resend";
const EMAIL_VERIFICATION_CONFIRM = BASE_URL + "users/email-verification/confirm";
const ACCEPT_POLICIES = BASE_URL + "users/accept-policies";
const DISCLAIMER_DISPLAYED = BASE_URL + "users/disclaimer-displayed";
const REFRESH = BASE_URL + "users/refresh";
const LOGOUT = BASE_URL + "users/logout";
const UPDATE_CURRENT_USER_PROFILE = BASE_URL + "users/me";

export function change_password_first_login(new_password, confirm_password) {
    return api
        .post(CHANGE_PASSWORD_FIRST_LOGIN, {
            new_password: new_password,
            confirm_password: confirm_password
        })
        .then(res => res.data)
        .catch(err => {
            message.error(err?.response?.data?.detail);
            throw err;
        });
}

export function accept_policies() {
    return api
        .post(ACCEPT_POLICIES, { accepted: true })
        .then(res => res.data)
        .catch(err => {
            message.error(err?.response?.data?.detail || i18n.t('users:policyAcceptance.errors.accept'));
            throw err;
        });
}

export function record_disclaimer_displayed() {
    return api
        .post(DISCLAIMER_DISPLAYED)
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}


export function get_all_users() {
    return api.get(GET_ALL_USERS).catch(error => {
        message.error(error).then(res => res.data)
            .catch(err => {
                throw err
            });
    });
}

export function create_user(payload) {
    return api
        .post(CREATE_USER, payload)
        .then(res => res.data)
        .catch(err => {
            message.error(err?.response?.data?.detail || i18n.t('users:messages.createError'));
            throw err;
        });
}

export function register_user(payload) {
    return axios
        .post(
            REGISTER_USER,
            payload,
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: false
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function request_password_reset(email) {
    return axios
        .post(
            PASSWORD_RESET_REQUEST,
            { email },
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: false
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function validate_password_reset(token) {
    return axios
        .post(
            PASSWORD_RESET_VALIDATE,
            { token },
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: false
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function confirm_password_reset(token, new_password, confirm_password) {
    return axios
        .post(
            PASSWORD_RESET_CONFIRM,
            { token, new_password, confirm_password },
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: true
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function resend_email_verification(email) {
    return axios
        .post(
            EMAIL_VERIFICATION_RESEND,
            { email },
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: false
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function confirm_email_verification(token) {
    return axios
        .post(
            EMAIL_VERIFICATION_CONFIRM,
            { token },
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: false
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function update_user(id, payload) {
    return api
        .put(UPDATE_USER + id, payload)
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function update_current_user_profile(payload) {
    return api
        .patch(UPDATE_CURRENT_USER_PROFILE, payload)
        .then(res => res.data);
}

export function delete_user(id_user) {
    return api
        .delete(DELETE_USER + id_user)
        .then(res => res.data)
        .catch(err => {
            throw err;
        });
}

export function login_user(email, password) {
    return axios
        .post(
            LOGIN_USER,
            {'email': email, 'password': password},
            {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Client-Language": getCurrentLanguage()
                },
                withCredentials: true
            }
        )
        .then(res => res.data)
        .catch(err => {
            throw err
        });
}

export function refresh_access_token() {
    return axios
        .post(
            REFRESH,
            {},
            {
                timeout: 15000,
                withCredentials: true
            }
        )
        .then(res => res.data)
        .catch(err => { throw err; });
}

export function logout_user() {
    return axios
        .post(
            LOGOUT,
            {},
            {
                timeout: 15000,
                withCredentials: true
            }
        )
        .then(res => res.data)
        .catch(err => { throw err; });
}

export function checkAuth() {
    return api
        .get("users/is-auth", { skipAuthRefresh: true })    // no body, token injecté par l'interceptor
        .then(res => res.data)   // { success: boolean, data: { is_authenticated: boolean }, ... }
        .catch(err => {
            throw err;
        });
}
